//const API_URL = 'http://localhost:8000/api'
const API_URL = 'https://fe7injrkq0.execute-api.ap-south-1.amazonaws.com/production/api'
const TITLE = 'The New Colllege'

module.exports = { API_URL, TITLE }